export const serverErrorHandler = (response) => {
  if (response?.data?.errorCode === 'U004' || response?.data?.errorMessage === 'server error') {
    // window.location.replace('/error');
    return;
  }
};
